import butter from '~/services/butter'	

export default ({ app }, inject) => {	
  inject('butter', butter)	
}